import { queryOptions, useMutation } from "@tanstack/react-query"

import { apiKey } from "@/lib/api/changes"
import { apiFetch } from "@/lib/api/client"
import type { ApiResource, Collection } from "@/lib/api/types"
import type {
  AddTeamMemberInput,
  ApiTeamEntry,
  OrganisationTeamEntry,
  OrganisationTeamFilters,
} from "@/types/organisation-team"

function toEntry(entry: ApiTeamEntry): OrganisationTeamEntry {
  return {
    id: entry.user_id,
    membershipId: entry.id,
    name: entry.name,
    email: entry.email,
    role: entry.role,
    avatarUrl: entry.avatar_url,
    lastActiveAt: entry.last_active_at,
    standing: entry.standing,
    actions: entry.actions,
  }
}

export const organisationTeamQueries = {
  list: (filters: OrganisationTeamFilters = {}) =>
    queryOptions({
      queryKey: apiKey("/team", filters),
      queryFn: async ({
        signal,
      }): Promise<Collection<OrganisationTeamEntry>> => {
        const { data } = await apiFetch<{
          data: ApiTeamEntry[]
          meta: { total: number }
        }>("/team", { params: filters, signal })

        return { items: data.map(toEntry) }
      },
    }),
}

export function useAddTeamMember() {
  return useMutation({
    mutationFn: async (input: AddTeamMemberInput) => {
      const { data } = await apiFetch<ApiResource<ApiTeamEntry>>("/team", {
        method: "POST",
        body: input,
      })

      return toEntry(data)
    },
  })
}

export function useRemoveTeamMember() {
  return useMutation({
    mutationFn: async (membershipId: string) => {
      await apiFetch<void>(`/team/${membershipId}`, { method: "DELETE" })

      return membershipId
    },
  })
}
